import styled from "styled-components";

export default styled.div`
  position: absolute;
  right: 0;
  top: 0;
  .rev__wrapper {
    width: 100px;
    font-size: 11px;
    line-height: 18px;
    height: 30px;
    letter-spacing: 0.38px;
    color: ${(props) => props.theme.colors.primary.main};
    border: 1px solid ${(props) => props.theme.colors.primary.main};
    border-radius: 4px;
    text-align: center;
    padding: 5px;
    margin-bottom: 5px;
  }

  @media screen and (max-width: 991px) {
    top: 25px;
    .rev__wrapper {
      padding: 3px;
      height: unset;
      line-height: unset;
    }
  }
`;
